"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultSignInStyles = exports.DefaultSignInPopperStyles = exports.DefaultPopperStyles = exports.DefaultPopperBoxStyles = exports.DefaultMenuCardStyes = exports.DefaultComponentStyles = exports.DefaultButtonStyles = void 0;
const DefaultButtonStyles = theme => {
    const navigationColors = theme.mixins.navigation.desktop;
    return {
      "&.popper__button": {
        alignItems: "center",
        backgroundColor: "transparent",
        borderBottom: `0.5rem solid ${navigationColors.primaryBorderColor}`,
        borderRadius: "0",
        color: navigationColors.primaryLinkColor,
        display: "inline-flex",
        fontFamily: theme.fontFamilies.semiBold,
        fontSize: "1.8rem",
        lineHeight: "1.2",
        justifyContent: "center",
        padding: "1.9rem 1.5rem",
        textTransform: "none",
        "@media (hover: none)": {
          "&:hover": {
            backgroundColor: "transparent"
          }
        },
        "@media (hover: hover)": {
          "&:hover": {
            backgroundColor: "transparent",
            borderBottom: `0.5rem solid ${navigationColors.primaryBorderColorHover}`,
            color: navigationColors.primaryLinkColorHover
          }
        },
        "&::after": {
          backgroundImage: `url("${process.env.PUBLIC_URL}/general/images/icons/icon_chevron--blue.svg")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "0.6rem 1rem",
          content: "''",
          display: "inline-block",
          height: "1rem",
          margin: "0 0 0 0.6rem",
          transform: "rotate(90deg)",
          width: "1rem"
        },
        "&.popper__button--isSelected": {
          fontFamily: theme.fontFamilies.bold,
          "&::after": {
            transform: "rotate(-90deg)"
          }
        }
      }
    };
  },
  DefaultComponentStyles = () => {
    return {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    };
  },
  DefaultMenuCardStyes = theme => {
    const navigationColors = theme.mixins.navigation.desktop;
    return {
      alignSelf: "flex-start",
      boxShadow: "unset",
      flex: "0 0 33%",
      margin: "0",
      minWidth: "33%",
      padding: "0 2rem",
      "ul": {
        display: "block",
        margin: "0 0 1rem",
        padding: "0"
      },
      "li": {
        display: "block",
        listStyle: "none",
        margin: "0",
        padding: "0"
      },
      "a": {
        color: navigationColors.tertiaryLinkColor,
        display: "inline-block",
        fontSize: "1.4rem",
        padding: "0.25rem 0",
        textDecoration: "none",
        "@media (hover: hover)": {
          "&:hover": {
            color: navigationColors.tertiaryLinkColorHover,
            fontFamily: theme.fontFamilies.bold,
            textDecoration: "underline"
          }
        },
        "&:focus-visible,&:active": {
          color: navigationColors.tertiaryLinkColorHover,
          fontFamily: theme.fontFamilies.bold,
          textDecoration: "underline"
        }
      },
      "> div > ul": {
        marginBottom: "2rem",
        "> li > ul": {
          borderTop: "0.1rem solid #EAEAEB",
          margin: "1rem 0 0",
          padding: "1rem 0 0"
        },
        "> li": {
          margin: "0 0 1.8rem"
        },
        "> li > a,> li > strong > a": {
          fontFamily: theme.fontFamilies.bold,
          fontSize: "1.8rem",
          fontWeight: "normal",
          "&:link, &:visited": {
            color: navigationColors.secondaryLinkColor
          },
          "@media (hover: hover)": {
            "&:hover": {
              color: navigationColors.secondaryLinkColorHover
            }
          },
          "&:focus-visible,&:active": {
            color: navigationColors.secondaryLinkColorHover
          }
        },
        "> li > a::after, > li > strong > a::after": {
          backgroundImage: `url("${process.env.PUBLIC_URL}/general/images/icons/icon_double-chevron--blue.svg")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          content: "''",
          display: "inline-block",
          height: "1.2rem",
          marginLeft: "1rem",
          width: "1.54rem"
        },
        "> li > a": {
          borderBottom: "0.1rem solid #eaeaeb",
          padding: "0 0 1rem",
          width: "100%"
        }
      }
    };
  },
  DefaultPopperBoxStyles = () => {
    return {
      alignItems: "center",
      display: "inline-flex",
      justifyContent: "flex-start"
    };
  },
  DefaultPopperStyles = theme => {
    return {
      backgroundColor: "white",
      backgroundImage: "linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 0, rgba(0, 0, 0, 0) 1rem)",
      display: {
        xs: "none",
        md: "block"
      },
      overflowX: "hidden",
      overflowY: "auto",
      padding: "3rem 0",
      width: "100%",
      zIndex: "5",
      "> *": {
        alignItems: "flex-start",
        display: "flex",
        justifyContent: "flex-start",
        maxWidth: `${theme.breakpoints.values["lg"]}${theme.breakpoints.unit}`,
        margin: "0 auto"
      }
    };
  },
  DefaultSignInStyles = theme => {
    const navigationColors = theme.mixins.navigation.desktop;
    return {
      alignItems: "center",
      display: "inline-flex",
      paddingLeft: "3rem",
      ".navigation__sign-in-button": {
        alignItems: "center",
        backgroundColor: navigationColors.signInButtonBackgroundColor,
        color: navigationColors.signInButtonColor,
        fontFamily: theme.fontFamilies.semiBold,
        justifyContent: "center",
        margin: "1rem 0",
        minHeight: "5.1rem",
        padding: "1rem 2.1rem",
        textTransform: "none",
        whiteSpace: "nowrap",
        "@media (hover: none)": {
          "&:hover": {
            backgroundColor: navigationColors.signInButtonBackgroundColor
          }
        },
        "@media (hover: hover)": {
          "&:hover": {
            backgroundColor: navigationColors.signInButtonBackgroundColorHover,
            color: navigationColors.signInButtonColorHover
          }
        },
        "&:active,&:focus-visible": {
          backgroundColor: navigationColors.signInButtonBackgroundColorHover,
          color: navigationColors.signInButtonColorHover
        },
        "&:before": {
          backgroundImage: `url("${process.env.PUBLIC_URL}/general/images/icons/sign-in-icon--white.svg")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "3rem 2.5rem",
          content: "''",
          display: "inline-block",
          height: "2.5rem",
          margin: "0 1rem 0 0",
          width: "3rem"
        },
        "&::after": {
          backgroundImage: `url("${process.env.PUBLIC_URL}/general/images/icons/icon_chevron--white.svg")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "0.6rem 1rem",
          content: "''",
          display: "inline-block",
          height: "1rem",
          margin: "0 0 0 0.6rem",
          transform: "rotate(90deg)",
          width: "1rem"
        },
        "&.navigation__sign-in-button--isSelected": {
          "&::after": {
            transform: "rotate(-90deg)"
          }
        }
      }
    };
  },
  DefaultSignInPopperStyles = theme => {
    const navigationColors = theme.mixins.navigation.desktop;
    return {
      display: {
        xs: "none",
        md: "block"
      },
      paddingTop: "1.9rem",
      zIndex: "5",
      ".navigation__sign-in-menu-panel": {
        padding: "1.2rem 0 2.4rem",
        overflowX: "hidden",
        overflowY: "auto"
      },
      ".navigation__sign-in-menu-wrapper": {
        backgroundColor: "rgba(255,255,255,0.9)",
        borderColor: navigationColors.signInButtonBackgroundColorHover,
        borderStyle: "solid",
        borderWidth: "0.8rem 0 0",
        boxShadow: "0 0.2rem 0.4rem rgba(0, 0, 0, 0.25)",
        lineHeight: "1.4",
        marginTop: "-1.9rem",
        padding: "0",
        position: "relative",
        "h2,h3": {
          borderBottom: "#D8D8D8 solid 0.1rem",
          color: "#3B4557",
          fontFamily: theme.fontFamilies.semiBold,
          fontSize: "1.8rem",
          letterSpacing: "2.25",
          lineHeight: "2.778",
          margin: "0 2.3rem 1rem",
          padding: "0 2.2rem 1rem",
          textTransform: "uppercase"
        },
        "ul": {
          display: "block",
          margin: "0",
          padding: "0"
        },
        "li": {
          display: "block",
          listStyle: "none",
          margin: "0",
          padding: "0"
        },
        "a": {
          display: "block",
          padding: "1rem 4.5rem",
          textDecoration: "none",
          "&,&:link,&:active,&:visited": {
            backgroundColor: navigationColors.signInLinkBackgroundColor,
            color: navigationColors.signInLinkColor
          },
          "@media (hover: none)": {
            "&:hover": {
              backgroundColor: navigationColors.signInLinkBackgroundColor
            }
          },
          "@media (hover: hover)": {
            "&:hover": {
              backgroundColor: navigationColors.signInLinkBackgroundColorHover,
              color: navigationColors.signInLinkColorHover
            }
          },
          "&:active,&:focus-visible": {
            backgroundColor: navigationColors.signInLinkBackgroundColorHover,
            color: navigationColors.signInLinkColorHover
          }
        },
        "&::after": {
          borderColor: `transparent transparent ${navigationColors.signInButtonBackgroundColorHover} transparent`,
          borderStyle: "solid",
          borderWidth: "0 2.2rem 1.3rem 2.2rem",
          content: "''",
          display: "block",
          height: "0",
          position: "absolute",
          right: "4.4rem",
          top: "-1.9rem",
          width: "0"
        }
      }
    };
  };

// Export component as default;
exports.DefaultSignInPopperStyles = DefaultSignInPopperStyles;
exports.DefaultSignInStyles = DefaultSignInStyles;
exports.DefaultPopperStyles = DefaultPopperStyles;
exports.DefaultPopperBoxStyles = DefaultPopperBoxStyles;
exports.DefaultMenuCardStyes = DefaultMenuCardStyes;
exports.DefaultComponentStyles = DefaultComponentStyles;
exports.DefaultButtonStyles = DefaultButtonStyles;